import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadMarkupListEpic } from './_epics/loadMarkupList.epic';
import { exportMarkupListEpic } from './_epics/exportMarkupList.epic';
import { updateMarkupEpic } from './_epics/updateMarkup.epic';
import { loadMarkupEpic } from './_epics/loadMarkup.epic';
import { bulkUpdateMarkupEpic } from './_epics/bulkUpdateMarkup.epic';
import { bulkRemoveMarkupEpic } from './_epics/bulkRemoveMarkup.epic';

export const markupEpic = safeCombineEpics(
  loadMarkupListEpic,
  exportMarkupListEpic,
  updateMarkupEpic,
  loadMarkupEpic,
  bulkUpdateMarkupEpic,
  bulkRemoveMarkupEpic,
);
